'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as SwitchPrimitive from '@radix-ui/react-switch';
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from './focus-ring';
/** Branded switch primitive preserving Radix form and controlled-state contracts. */ export const SpecraSwitch = /*#__PURE__*/ React.forwardRef(({ className, onChange, onCheckedChange, ...props }, ref)=>/*#__PURE__*/ _jsx(SwitchPrimitive.Root, {
        className: cn(`inline-flex h-[var(--switch-height)] w-[var(--switch-width)] shrink-0 cursor-pointer items-center rounded-[var(--radius-pill)] border-0 p-[var(--space-0-5)] transition-colors duration-[var(--dur-base)] ease-[var(--ease-standard)] data-[state=checked]:bg-primary data-[state=unchecked]:bg-[var(--switch-track-unchecked)] disabled:cursor-not-allowed disabled:opacity-50 ${specraFocusRing}`, className),
        onCheckedChange: (checked)=>{
            onCheckedChange?.(checked);
            onChange?.(checked);
        },
        ref: ref,
        ...props,
        children: /*#__PURE__*/ _jsx(SwitchPrimitive.Thumb, {
            className: "pointer-events-none block size-[var(--switch-thumb)] rounded-full bg-[var(--switch-thumb-background)] shadow-[var(--shadow-sm)] transition-transform duration-[var(--dur-base)] ease-[var(--ease-standard)] data-[state=checked]:translate-x-[var(--switch-travel)] data-[state=unchecked]:translate-x-0"
        })
    }));
SpecraSwitch.displayName = 'SpecraSwitch';
